module.exports = __webpack_public_path__ + "img/qfljwb-l8g1-4.prt.1c5d0288.jpg";